// must match the runtimeCaching cache names in vite.config.deployment.mts
const MAP_CACHE_NAMES = ['google-maps-cache', 'google-maps-tiles-cache']

let purge: Promise<boolean> | undefined

/**
 * Deletes the service worker's Google Maps caches, once per page load. Never rejects, and resolves to
 * whether anything was deleted. The map refetches its code and tiles as they're needed.
 */
export const purgeMapCaches = (): Promise<boolean> => {
  if (!purge) {
    purge =
      typeof caches === 'undefined'
        ? Promise.resolve(false)
        : Promise.all(MAP_CACHE_NAMES.map((cacheName) => caches.delete(cacheName)))
            .then((deleted) => deleted.some(Boolean))
            .catch(() => false)
  }

  return purge
}
